module.exports = require('./helpers/bundle-url').getBundleURL('jbGzv') + "logo-dark.eefe0b7f.svg";